module.exports = {"menuToggle":"메뉴 열림/닫힘","home":"홈","voicecaddie":"보이스캐디","alarm":"알람","clubBi":"골프클럽 BI"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/header.json
// module id = FbmW
// module chunks = 2